import React from 'react';

import parse from 'html-react-parser';

const Seo = ({ seo, pageContext, location, jobSchema, metaTitle = null }) => {

    //Set up yoast variables
    
    let { fullHead, title } = seo || {};
    
    const { hardCodeMetaDescription } = (typeof pageContext !== 'undefined') ? pageContext : {};

    let metaDescription = null;

    let canonicalPattern = `<link .*.canonical.(.*?)/>`;
    let canonical = fullHead?.match(canonicalPattern);

    //This is hacky, but we are wanting to make sure the url is prefixed
    //It has a check to make sure there is no url from yoast, if not then prefix the live url
    let newCanonical = null;

    if(canonical) {
        newCanonical = canonical[0];
    }
    
    //Check to make sure the url isn't already a fix url
    //If it was then we don't need to do anything, it is already optimum 
    if (newCanonical && newCanonical.indexOf('https://') < 0) {

        let tempNewCanonical = newCanonical.split(`href="`);

        let checkUS = "";
        
        if(process.env.GATSBY_locale === "en-US") {
            checkUS = "us.";
        }

        //Hackity hack hack
        if(location && location.pathname !== "/stories/" && location.pathname !== "/blog/") {
            tempNewCanonical[1] = `${location.pathname} />`
        }else{
            tempNewCanonical[1] = tempNewCanonical[1].replace('"', "");
        }

        newCanonical = `${tempNewCanonical[0]}href=https://${checkUS}flauntdigital.com${tempNewCanonical[1]}`;

        //We have finished our hacks, lets put it in the head string.
        fullHead = fullHead.replace(canonical[0],newCanonical);
    }

    //This is hacky, Not a big fan. I've popped this in for the archive pages as there is not a clean wait to add this through Yoast. 
    //Try to avoid adding new items here if possible. Instead add them in wordpress through yoast. 
    //Video on how to add meta descriptions in yoast - https://www.youtube.com/watch?v=eBGIQ7ZuuiU
    switch (hardCodeMetaDescription) {
        case 'stories':
            metaDescription = <meta name="description" content="Read all about what we’ve done, how we’ve done it and the results we’ve driven. Step right this way for Flaunt Digital case studies." />;
            break;
        case 'blog':
            metaDescription = <meta name="description" content="Mammoth insight from Flaunt Digital’s team of digital strategists, taking an in-depth look at some of the world’s most interesting industries." />;
            break;
        case 'reports':
            metaDescription = <meta name="description" content="Flaunt Digital employs experts, graduates, novices, but most importantly, we employ kind people. If that’s you, click here to find out what it’s like to work for us." />
            break;
        default :
            metaDescription = <meta name="description" content="Flaunt Digital employs experts, graduates, novices, but most importantly, we employ kind people. If that’s you, click here to find out what it’s like to work for us." />
            break;
    }

    let slug;
    let noIndex = false;

    if(canonical){
        slug = canonical[1].substring(
            canonical[1].indexOf('"') + 1, 
            canonical[1].lastIndexOf('"')
        );
    }

    if(canonical === null) {
        noIndex = true;
    }

    if(slug && slug.includes("https")) {
        slug = "";
    }

    if(location) {
        slug = location.pathname;
    }
    
    return (
        <>
            <title>{ title ? title : metaTitle }</title>
            { fullHead && parse(fullHead) }
            { metaDescription }
            <meta name="robots" content={`${noIndex ? "noindex," : ""}max-image-preview:large`}></meta>
            <link rel="alternate" href={`https://flauntdigital.com${slug}`} hrefLang="en-GB"></link>
            <link rel="alternate" href={`https://us.flauntdigital.com${slug}`} hrefLang="en-US"></link>
            <link rel="alternate" href={`https://flauntdigital.com${slug}`} hrefLang="x-default"></link>
            { jobSchema &&
                <script type="application/ld+json">
                    {`${JSON.stringify(jobSchema)}`}
                </script>
            }
        </>
    );
};

export default Seo;